"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var AcdcContext_1 = require("./AcdcContext");
var useAcdcReducer_1 = require("./useAcdcReducer");
var useBlurHandler = function (action) {
    var dispatch = AcdcContext_1.useAcdcContext().dispatch;
    var _a = AcdcContext_1.useAcdcElementRegistryContext(), getPopupElement = _a.getPopupElement, getInputElement = _a.getInputElement;
    var rafRef = react_1.useRef();
    react_1.useEffect(function () { return function () { return cancelAnimationFrame(rafRef.current); }; }, []);
    var handleBlur = react_1.useCallback(function (e) {
        if (e.defaultPrevented) {
            return;
        }
        rafRef.current = requestAnimationFrame(function () {
            var focusedEl = document.activeElement;
            var popupElement = getPopupElement();
            var inputElement = getInputElement();
            if (popupElement && popupElement.contains(focusedEl)) {
                return;
            }
            if (inputElement && inputElement.contains(focusedEl)) {
                return;
            }
            dispatch(action);
        });
    }, [dispatch, getPopupElement, getInputElement]);
    return handleBlur;
};
function useInputBlurHandler() {
    return useBlurHandler({ type: useAcdcReducer_1.ActionTypes.InputBlur });
}
exports.useInputBlurHandler = useInputBlurHandler;
function usePopupBlurHandler() {
    return useBlurHandler({ type: useAcdcReducer_1.ActionTypes.PopupBlur });
}
exports.usePopupBlurHandler = usePopupBlurHandler;
